import { type Schedule } from "./types";

export function messagePerMonthFromSchedule(schedule: Schedule): number {
    const { frequency, date } = schedule;
    if (frequency === 'daily') return 30;
    if (frequency === 'weekly') {
        const daysOfWeek = date.split(',').map(d => d.trim());
        return daysOfWeek.length * 4; // Approximate 4 weeks in a month
    }
    if (frequency === 'monthly') return 1;
    if (frequency === 'yearly') {
        const scheduleDate = new Date(`${date}T00:00:00`);
        const now = new Date();
        if (
            scheduleDate.getMonth() === now.getMonth() &&
            scheduleDate.getFullYear() === now.getFullYear()
        ) {
            return 1;
        }
        return 0;
    }
    if (frequency === 'onetime') {
        const scheduleDate = new Date(`${date}T00:00:00`);
        const now = new Date();
        if (
            scheduleDate.getFullYear() === now.getFullYear() &&
            scheduleDate.getMonth() === now.getMonth()
        ) {
            return 1;
        }
        return 0;
    }
    console.warn(`Unknown frequency "${frequency}" in schedule ${schedule.id}, defaulting to 1 message per month`);
    return 1;
}

export function planMaxMessages(plan: 'free' | 'plus' | 'pro'): number {
    switch (plan) {
        case 'free':
            return 10;
        case 'plus':
            return 100;
        case 'pro':
            return 1000;
        default:
            console.warn(`Unknown plan "${plan}", defaulting to free tier max messages`);
            return 10;
    }
}
